import { TabGeneralProps } from './tab-general.type'

import {
  CardCancellationReason,
  CardExpectedPaymentDate,
  CardShipmentStatus,
  CardSupplyOrderDetail,
  CardSupplyOrderOrdersDetail,
  CardSupplyOrderSupplier,
  CardSupplyOrderTotalValues,
} from './components'

import styles from './tab-general.module.css'

export const TabGeneral = ({ supplyOrder, isLoading }: TabGeneralProps) => {
  return (
    <div className={styles.container}>
      <div>
        {supplyOrder?.status === 'cancelled' && (
          <div>
            <CardCancellationReason
              isLoading={!!isLoading}
              cancellationReason={supplyOrder.cancellationReason}
              cancellationDescription={supplyOrder?.cancellationDescription}
            />
          </div>
        )}

        <div className={styles.row}>
          <CardExpectedPaymentDate isLoading={!!isLoading} data={supplyOrder} />
          <CardShipmentStatus isLoading={!!isLoading} data={supplyOrder} />
        </div>

        <div>
          <CardSupplyOrderDetail isLoading={isLoading} data={supplyOrder} />
        </div>

        <div>
          <CardSupplyOrderOrdersDetail
            isLoading={isLoading}
            saleOrders={supplyOrder?.saleOrders?.map(
              (saleOrder) => saleOrder?.reference,
            )}
          />
        </div>
      </div>
      <div>
        <div>
          <CardSupplyOrderTotalValues
            isLoading={isLoading}
            data={supplyOrder}
          />
        </div>

        <div>
          <CardSupplyOrderSupplier
            isLoading={isLoading}
            supplier={supplyOrder?.supplier}
          />
        </div>
      </div>
    </div>
  )
}
